import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/bricolage-grotesque';
import App from './App.tsx';
// Imported for its side effect: it catches Chromium's one-shot install prompt at startup.
import './lib/install.ts';
import { applyTheme, cachedPrefs } from './lib/prefs.ts';
import './styles.css';

// Before the first render, so a dark-theme user never sees a white flash on launch.
applyTheme(cachedPrefs());

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
